var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from "react";

function SvgEmission(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21.704 11.013a2.8 2.8 0 114.686 3.066 3.997 3.997 0 01-2.46 7.203 3.22 3.22 0 01-3.13 2.542c-.331 0-.661-.052-.977-.154a3.196 3.196 0 01-3.023 2.154h-6.4v.8a.4.4 0 01-.4.4H8.4a.4.4 0 01-.4-.4v-.4H4.4a.4.4 0 01-.4-.4v-3.2a.4.4 0 01.4-.4H8v-.4a.4.4 0 01.4-.4H10a.4.4 0 01.4.4v.8h.828a2.802 2.802 0 013.39-2.331 3.25 3.25 0 01.618-.457 3.198 3.198 0 01.787-4.127l-.033-.041a3.598 3.598 0 115.618-4.496 2.58 2.58 0 01.096-.159zM9.6 22.223h-.8v4h.8v-4zm-1.6.8H4.8v2.4H8v-2.4zm16.49-12.349a2 2 0 00-2.425 1.455.4.4 0 01-.748.075 2.798 2.798 0 10-4.408 3.28.4.4 0 01-.076.644 2.4 2.4 0 00-.69 3.618.4.4 0 01-.17.628c-.36.134-.682.352-.94.636a.4.4 0 01-.419.11A2 2 0 0012 23.024a.4.4 0 01-.4.4h-1.2v1.6h6.4a2.395 2.395 0 002.359-1.967.4.4 0 01.572-.286 2.38 2.38 0 001.07.254 2.411 2.411 0 002.389-2.2.397.397 0 01.145-.276.392.392 0 01.3-.088 3.198 3.198 0 001.985-5.934.4.4 0 01-.1-.605 2 2 0 00-1.03-3.247zm1.11 11.15a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4zm0 .8a.4.4 0 100 .8.4.4 0 000-.8zm-13.2-6.8a1.6 1.6 0 110 3.2 1.6 1.6 0 010-3.2zm0 .8a.8.8 0 100 1.6.8.8 0 000-1.6zM24 5.024a2 2 0 110 4 2 2 0 010-4zm0 .8a1.2 1.2 0 100 2.4 1.2 1.2 0 000-2.4z"
  }));
}

export default SvgEmission;